export enum ProductStatus {
    unlocked = 'Desbloqueado',
    lockSold = 'Bloqueado para venda',
    lock = 'Bloqueado para abastecimento',
}

export type EnumType = typeof ProductStatus;
export type EnumKeyType = keyof EnumType;

export function getProductStatus(): ProductStatus[] {
    return Object.values(ProductStatus);
}

export function getPropertyNamesFromProductStatus(): string[] {
    return Object.getOwnPropertyNames(ProductStatus);
}

type BarCode = {
    id: number;
    code: string;
};

export interface PlanogramFromAPI {
    id: number;
    planogram_code: string;
    standard_amount: number;
    stock_amount: number;
    status: string;
    alert_level: number;
    price_list_in_cents: number;
    price_final_in_cents: number;
    product: {
        name: string;
        id: number;
        BarCodes: BarCode[];
        package_multiplier: number;
        Category: {
            name: string;
        };
    };
}
